module.exports = __webpack_public_path__ + "img/ic-user-info.36bf1079.svg";